export const GET_TIPOLOGIAS_REQUEST = 'GET_TIPOLOGIAS_REQUEST';
export const GET_TIPOLOGIAS_SUCCESS = 'GET_TIPOLOGIAS_SUCCESS';
export const GET_TIPOLOGIAS_FAILURE = 'GET_TIPOLOGIAS_FAILURE';
